import axios from 'axios';
import { AppConfig } from 'AppConfig';
import LocalStore from 'utils/LocalStore';
import { requestWithTenantSwitchRetry } from 'networking/tenantSwitchRetry';

/**
 * Fetch performance metrics data from API.
 * @returns {Promise<Object>}
 */
export async function getReportsData() {
  const url = `${AppConfig.FO_INITIAL_URL}/report/all`;
  // Rebuilt per attempt so a retry picks up the token minted by a tenant switch.
  const buildHeaders = () => ({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + LocalStore.getAccessToken()
  });
  const response = await requestWithTenantSwitchRetry(() =>
    axios.get(url, { headers: buildHeaders() })
  );
  return response.data;
}